function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#faefde",
  d: "M31.936 10.226a22 22 0 100 44 22 22 0 100-44z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff7f0",
  d: "M13.649 53.513a27.998 27.998 0 009.177 5.823l34.11-34.11V18.8a28.065 28.065 0 00-3.713-4.861L13.649 53.513zm-1.949-2.05l39.237-39.237h-6L9.157 48.005a28.04 28.04 0 002.543 3.458zm-2.969-7.032l33.205-33.205-3-2L7.3 40.862a27.851 27.851 0 001.431 3.569z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#faefde",
  d: "M31.936 4.226c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28-12.536-28-28-28zm0 50c-12.15 0-22-9.85-22-22s9.85-22 22-22a21.927 21.927 0 0115.851 6.744 21.915 21.915 0 016.149 15.256c0 12.15-9.849 22-22 22z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#efd8be",
  d: "M32 54c-12.15 0-22-9.85-22-22H8.339c-2.491 0-4.361 2.25-3.945 4.706C6.631 49.929 18.14 60 32 60s25.369-10.071 27.606-23.294C60.022 34.25 58.152 32 55.661 32H54c0 12.15-9.85 22-22 22z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#ed7899",
  d: "M29 45V27l-5 5-4-4 12-12 12 12-4 4-5-5v18z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#72caaf",
  d: "M62.9 61.91c.05.59-.41 1.09-1 1.09H38.1c-.59 0-1.05-.5-1-1.09l.54-5.91 1.28-14.09c.04-.52.48-.91.99-.91h20.18c.51 0 .95.39.99.91L62.36 56l.54 5.91z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#72caaf",
  d: "M62.9 61.91c.05.59-.41 1.09-1 1.09H38.1c-.59 0-1.05-.5-1-1.09l.125.635A5 5 0 0142.204 58h15.592a5 5 0 014.979 4.545l.125-.635z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M39.351 12.322a21.24 21.24 0 012.099.919 1 1 0 00.902-1.785 23.215 23.215 0 00-2.3-1.007 1 1 0 10-.701 1.873zM32 51a1 1 0 00-1 1v2a1 1 0 002 0v-2a1 1 0 00-1-1zm-9.25-2.479a1 1 0 00-1.366.366l-1 1.732a1 1 0 001.732 1l1-1.732a1 1 0 00-.366-1.366zm4.462 1.849a.998.998 0 00-1.225.707l-.518 1.932a1 1 0 001.931.518l.518-1.932a.998.998 0 00-.706-1.225zM11 32a20.864 20.864 0 016.151-14.849 21.067 21.067 0 0118.187-5.886 1 1 0 00.317-1.975 23.076 23.076 0 00-19.917 6.446C11.393 20.081 9 25.856 9 32s2.393 11.919 6.737 16.263a.997.997 0 001.414 0 .999.999 0 000-1.414A20.864 20.864 0 0111 32zm35.849-14.849A20.864 20.864 0 0153 32a1 1 0 002 0 22.848 22.848 0 00-6.737-16.263 23.2 23.2 0 00-2.093-1.856 1 1 0 10-1.234 1.574 21.105 21.105 0 011.913 1.696z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M40.707 32.707l4-4a.999.999 0 000-1.414l-12-12a.999.999 0 00-1.414 0l-12 12a.999.999 0 000 1.414l4 4a.999.999 0 001.414 0L28 29.414V45a1 1 0 001 1h6a1 1 0 001-1V29.414l3.293 3.293a.999.999 0 001.414 0zm-5-6.414A1.002 1.002 0 0034 27v17h-4V27a1.002 1.002 0 00-1.707-.707L24 30.586 21.414 28 32 17.414 42.586 28 40 30.586l-4.293-4.293z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#8d6c9f",
  d: "M62.08 41.82c-.1-1.04-.95-1.82-1.99-1.82h-.22c.74-2.54 1.13-5.22 1.13-8C61 16.01 47.99 3 32 3S3 16.01 3 32s13.01 29 29 29c1.43 0 2.83-.1 4.2-.3l-.1 1.12c-.05.56.14 1.11.52 1.53.38.41.91.65 1.48.65h23.8c.57 0 1.1-.24 1.48-.65.38-.42.57-.97.52-1.53l-1.82-20zM32 59C17.11 59 5 46.89 5 32S17.11 5 32 5s27 12.11 27 27c0 2.78-.42 5.47-1.21 8h-.87c-.488-3.387-3.401-6-6.92-6s-6.432 2.613-6.92 6h-3.17c-1.04 0-1.89.78-1.99 1.82l-1.53 16.82c-1.43.24-2.9.36-4.39.36zm22.899-19h-9.798c.465-2.279 2.484-4 4.899-4s4.434 1.721 4.899 4zM38.1 62l.15-1.68.19-2.1L39.91 42H43v2a1 1 0 002 0v-2h10v2a1 1 0 002 0v-2h3.09l1.81 20H38.1z"
});

function SvgUpgrade(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 256,
    height: 256
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
}

export default SvgUpgrade;